import { render, staticRenderFns } from "./MomoProductItem.vue?vue&type=template&id=245a6f54&"
import script from "./MomoProductItem.vue?vue&type=script&lang=js&"
export * from "./MomoProductItem.vue?vue&type=script&lang=js&"
import style0 from "./MomoProductItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports